export default "__VITE_ASSET__dzR4_xho__";